export const TRACKING = 0

export const space = {
  _2xs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  _2xl: 24,
  _3xl: 28,
  _4xl: 32,
  _5xl: 40,
} as const

export const fontSize = {
  _2xs: 9.4,
  xs: 11.3,
  sm: 13.1,
  md: 15,
  lg: 16.9,
  xl: 18.8,
  _2xl: 20.6,
  _3xl: 24.3,
  _4xl: 30,
  _5xl: 37.5,
} as const

export const lineHeight = {
  tight: 1.15,
  snug: 1.3,
  relaxed: 1.5,
} as const

export const borderRadius = {
  _2xs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  full: 999,
} as const

export const fontWeight = {
  normal: '400',
  medium: '500',
  semiBold: '600',
  bold: '700',
} as const

export const labelerColor = {
  purple: 'rgb(105 0 255)',
  purple_dark: 'rgb(83 0 202)',
} as const
